import { render, staticRenderFns } from "./MakeImpactGoalEditable.vue?vue&type=template&id=7f2eb4bd"
import script from "./MakeImpactGoalEditable.vue?vue&type=script&setup=true&lang=ts"
export * from "./MakeImpactGoalEditable.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./MakeImpactGoalEditable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports